export const MASK = '••••';

interface Options {
  visibleHead?: number;
  visibleTail?: number;
  mask?: string;
}

export const maskString = (
  value: string,
  { visibleHead = 4, visibleTail = 4, mask = MASK }: Options = {},
) => {
  if (value.length <= visibleHead + visibleTail) {
    return mask;
  }

  return `${value.slice(0, visibleHead)}${mask}${value.slice(-visibleTail)}`;
};
